import { AI_CONTEXT_LEVEL_DEFAULT, AI_CONTEXT_LEVEL_STORAGE_KEY } from './ai-assist-shell.constants';
import { EAiContextLevel } from './ai-assist-shell.interface';

/** The context level the viewer picked last; a browser that refuses storage just gets the default. */
export function readAiContextLevel(): EAiContextLevel {
  try {
    const stored: string | null = localStorage.getItem(AI_CONTEXT_LEVEL_STORAGE_KEY);

    return Object.values<string>(EAiContextLevel).includes(stored ?? '')
      ? (stored as EAiContextLevel)
      : AI_CONTEXT_LEVEL_DEFAULT;
  } catch {
    return AI_CONTEXT_LEVEL_DEFAULT;
  }
}

export function saveAiContextLevel(level: EAiContextLevel): void {
  try {
    localStorage.setItem(AI_CONTEXT_LEVEL_STORAGE_KEY, level);
  } catch {
    // A browser that refuses storage just forgets the choice; the dialog still works.
  }
}

/**
 * The user's own request is the only thing left to ask with: no quick action is picked, or the agent has nothing to
 * read. `hasLinkedContext` (the items an unsaved form has linked) only reaches the agent from level "standard" on,
 * so at "basic" an empty source stays empty.
 */
export function isAiAssistPromptRequired(request: {
  contextLevel: EAiContextLevel;
  hasLinkedContext: boolean;
  isSourceEmpty: boolean;
  selectedAction: string | null;
}): boolean {
  const hasSomethingToRead: boolean =
    !request.isSourceEmpty || (request.hasLinkedContext && request.contextLevel !== EAiContextLevel.basic);

  return !hasSomethingToRead || request.selectedAction === null;
}
